/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationActionConfig
 */
export interface AutomationActionConfig {
    /**
     * Form template to send to the homeowner
     * @type {number}
     * @memberof AutomationActionConfig
     */
    formTemplateId: number;
}

/**
 * Check if a given object implements the AutomationActionConfig interface.
 */
export function instanceOfAutomationActionConfig(value: object): value is AutomationActionConfig {
    if (!('formTemplateId' in value) || value['formTemplateId'] === undefined) return false;
    return true;
}

export function AutomationActionConfigFromJSON(json: any): AutomationActionConfig {
    return AutomationActionConfigFromJSONTyped(json, false);
}

export function AutomationActionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationActionConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'formTemplateId': json['formTemplateId'],
    };
}

export function AutomationActionConfigToJSON(json: any): AutomationActionConfig {
    return AutomationActionConfigToJSONTyped(json, false);
}

export function AutomationActionConfigToJSONTyped(value?: AutomationActionConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formTemplateId': value['formTemplateId'],
    };
}

